<template>
  <div class="list-container">
    <div class="list-header">
      <div class="flag">名单库分类</div>
      <el-button
        type="text"
        @click="handleEdit(1)"
        class="el-icon-circle-plus-outline"
        title="新增"
      ></el-button>
    </div>
    <div class="list-content">
      <el-scrollbar style="height: 100%">
        <div
          class="list-item"
          v-for="(items, index) in blackListData"
          :key="index"
        >
          <div class="item-title" @click="items.show = !items.show">
            <span>
              {{ items.name }}
            </span>
            <el-button
              type="text"
              :class="items.show ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            ></el-button>
          </div>
          <el-collapse-transition>
            <ul class="itemChildren" v-show="items.show">
              <li
                v-for="(item, childrenIndex) in items.children"
                :key="childrenIndex"
                :class="['list-text', item.code == nowCode.code ? 'check' : '']"
                @click="handleNodeClick(item)"
              >
                <span class="list-name">{{ item.name | ellipsis }}</span>

                <span v-if="item.code == nowCode.code">
                  <el-button
                    type="text"
                    @click.stop="handleEdit(2, item)"
                    class="el-icon-edit-outline"
                    size="mini"
                    title="修改"
                  ></el-button>
                  <el-button
                    type="text"
                    @click.stop="handleDel"
                    v-auth="'/personMg:delete'"
                    class="el-icon-delete-solid"
                    size="mini"
                    title="删除"
                  ></el-button>
                </span>
              </li>
            </ul>
          </el-collapse-transition>
        </div>
      </el-scrollbar>
    </div>
    <!-- 新增弹窗 -->
    <el-dialog
      :title="state === 1 ? '新增名单组' : '编辑名单组'"
      v-ops:width="550"
      :visible.sync="formShow"
      @close="formClose"
      :close-on-click-modal="false"
    >
      <el-form
        label-width="100px"
        :model="formData"
        ref="formData"
        :rules="rules"
      >
        <el-form-item label="所属分类" prop="type">
          <el-select
            style="width: 100%"
            :disabled="state === 1 ? false : true"
            v-model="formData.type"
            placeholder="请选择所属分类"
          >
            <el-option
              v-for="item in blackListData"
              :key="item.type"
              :label="item.name"
              :value="item.type"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="人脸库类型"
          prop="repositoriesType"
          v-if="formData.type == 3"
        >
          <el-select
            style="width: 100%"
            v-model="formData.repositoriesType"
            placeholder="请选择类型"
          >
            <el-option
              v-for="item in repositoriesType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名单组名称" prop="name">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="formClose" :subLoading="subLoading">
          {{ subLoading ? "提交中" : $t("personMg.button.cancel") }}
        </el-button>
        <el-button type="primary" @click="addBackList" :subLoading="subLoading">
          {{ subLoading ? "提交中" : $t("personMg.button.save") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../api";
import { Dic } from "$utils";
export default {
  data() {
    return {
      repositoriesType: [
        { label: "VIP人员", value: 1 },
        { label: "普通人员", value: 2 },
      ],
      rules: {
        name: [
          {
            required: true,
            message: "请输入名单组名称",
            trigger: "change",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择所属分类",
            trigger: "change",
          },
        ],
        repositoriesType: [
          {
            required: true,
            message: "请选择人脸类型",
            trigger: "change",
          },
        ],
      },
      nowIndex: {
        parentIndex: 0,
        childrenIndex: 0,
      },
      nowCode: { type: -1 }, // 当前名单组数据
      formShow: false,
      subLoading: false,
      state: 1, // 1: 新增 2：修改
      // 表单数据
      formData: {
        name: "", //名称
        type: "", //类型
        repositoriesType: "", //人脸类型
      },
      blackListData: [], //名单组列表
      defaultProps: {
        children: "children",
        label: "name",
      },
    };
  },
  created() {
    this.queryFaceType();
  },
  mounted() {
    this.getBlackList();
  },
  methods: {
    handleEdit(type, item) {
      this.state = type;
      this.formShow = true;
      if (item) {
        this.formData = {
          name: item.name,
          type: item.type,
          repositoriesType: item.repositoriesType,
        };
      }
    },
    // 新增修改弹窗 关闭清除数据
    formClose() {
      this.$refs["formData"].resetFields();
      this.formShow = false;
    },
    // 删除
    handleDel(item) {
      if (this.nowCode.type === -1) {
        this.$message.warning(this.$t("personMg.placeholder.choseGroup"));
        return false;
      }
      this.$confirm(this.$t("personMg.message.groupDel"), "删除确认", {
        confirmButtonText: this.$t("personMg.button.confirm"),
        cancelButtonText: this.$t("personMg.button.cancel"),
        type: "warning",
      }).then(() => {
        this.$fetch(api.deleteFaceGroup, {
          code: this.nowCode.code,
        }).then((res) => {
          if (res.success) {
            this.nowCode = {};
            this.$message.success(this.$t("personMg.message.successDel"));
            this.getBlackList();
          } else {
            this.$message.error(res.msgContent);
          }
        });
      });
    },
    // 新增/修改名单组
    addBackList() {
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          let url = this.state === 1 ? api.addFaceGroup : api.updateFaceGroup;
          let params = {};
          if (this.state === 1) {
            params = {
              name: this.formData.name,
              type: this.formData.type,
            };
          } else {
            params = {
              name: this.formData.name,
              code: this.nowCode.code,
            };
          }
          if (params.type == 3) {
            params.repositoriesType = this.formData.repositoriesType;
          }
          this.subLoading = true;
          this.$fetch(url, params).then((res) => {
            this.subLoading = false;
            if (res.success) {
              this.$message.success(
                this.state === 1
                  ? this.$t("personMg.title.addOk")
                  : this.$t("personMg.title.editOk")
              );
              this.formClose();
              this.getBlackList();
            } else {
              this.$message.error(
                this.state === 1 ? res.msgContent : res.msgContent
              );
            }
          });
        } else {
          return false;
        }
      });
    },
    // 请求名单组
    getBlackList() {
      this.$fetch(api.queryGroup, {
        name: this.name,
      }).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
          return false;
        }
        this.blackListData.forEach((item) => {
          item.children.length = 0;
        });
        res.returnObj.map((item1) => {
          this.blackListData.map((item2) => {
            if (item1.type === item2.type) {
              item2.children.push(item1);
            }
          });
        });
        console.log(this.nowCode);
        if (!this.nowCode.code) {
          this.blackListData.some((item, ind) => {
            if (item.children && item.children[0]) {
              this.handleNodeClick(item.children[0]);
              return true;
            }
          });
        }
      });
    },
    // 名单组点击回调
    handleNodeClick(data) {
      this.nowCode = data;
      this.$emit("queryTable", this.nowCode);
      console.log(this.nowCode);
    },
    queryFaceType() {
      Dic.find("SENU027").map((item, ind) => {
        this.blackListData.push({
          name: item.label,
          type: item.value,
          isParent: true,
          show: true,
          children: [],
        });
      });
      console.log(this.blackListData, "blackListData");
    },
  },
};
</script>
<style scoped lang="scss">
@import "~@src/common/assets/style/mixin";
.list-container {
  .el-button {
    // color: #fff !important;
  }
  height: 100%;
  .list-header {
    margin-top: 5px;
    position: relative;
    .flag {
      border-left: 6px solid #407aee;
      padding-left: 10px;
      height: 14px;
      font-size: 14px;
      font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
      font-weight: 400;
      // color: #e8eaee;
      line-height: 14px;
    }
    .el-button {
      font-size: 18px;
      position: absolute;
      top: -10px;
      right: 10px;
    }
  }
  .list-content {
    height: calc(100% - 50px);
    margin-top: 15px;
    .itemChildren {
      // background: #1e2534;
    }
    .item-title {
      // color: #fff;
      @include set_theme_color(background-color,page-default-bg);
      // background: #0d121c;
      padding: 8px 9px;
      cursor: pointer;
      .el-button {
        font-size: 15px;
      }
    }
    .list-text {
      padding: 8px 9px;
      @include set_theme_color(background-color,page-bg-color);
      border-bottom: 1px solid #3b4253;
      @include set_theme_color(border-color,border-color);
      cursor:pointer;
      &:hover {
        // background: #0d121c;
      }
      &.check {
        // background: #0d121c;
      }
    }
    .list-text:last-child {
      border-bottom: none;
    }
    .item-title,
    .list-text {
      font-size: 14px;
      height: 40px;
      font-weight: 400;
      // line-height: 14px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
.iconStyle {
  position: absolute;
  right: 10px;
  top: 25%;
  padding: 1px 2px 1px 2px;
  // background: #383f6e;
}
</style>
>
